import React, { ReactNode } from "react";
import styles from "./spacer-16.module.scss";

interface Spacer16PropTypes {
  children?: ReactNode;
}

const cssClassName = "spacer-16";

export const Spacer16 = ({ children }: Spacer16PropTypes) => {
  return <div className={styles[cssClassName]}>{children}</div>;
};
